import { useCallback } from "react";
import { defineMessages } from "react-intl";

import Button from "../Buttons/Button";
import UploaderFileTransfer from "../Uploader/UploaderFileTransfer";
import { truncateCentered } from "../../helpers/StringHelper";
import Icon from "../Utils/Icon";
import { useFormatMessage } from "../Intl/Context";
import {
  UPLOAD_STATUS_COMPLETED,
  UPLOAD_STATUS_IN_PROGRESS
} from "../Uploader/useDirectFileUpload";
import { useFieldErrors } from "../Form/useFieldErrors";

const FileInputFile = props => {
  const {
    file,
    onUploadStart,
    onUploadComplete,
    onRemove,
    attachmentToken,
    inputFieldName
  } = props;

  const t = useFormatMessage();
  const removeFileLabel = t(intlMessages.removeFile);

  const { addErrors } = useFieldErrors(inputFieldName);

  const filename =
    file &&
    // When the file has been uploaded, the #filename property is
    // available and can be modified in the back-office, so we use it
    (file.filename ||
      // When the file has just been selected and is not uploaded yet,
      // we use the javascript File object's #name property
      file.name);

  const displayName = truncateCentered(filename, 32);

  const handleUploadStarted = useCallback(
    data => {
      file.key = data.key;
      file.status = UPLOAD_STATUS_IN_PROGRESS;

      onUploadStart();
    },
    [file, onUploadStart]
  );

  const handleUploadCompleted = useCallback(
    data => {
      file.key = data.key;
      file.url = data.url;
      file.filename = data.filename;
      file.status = UPLOAD_STATUS_COMPLETED;

      onUploadComplete();
    },
    [file, onUploadComplete]
  );

  const handleUploadError = useCallback(
    error => {
      addErrors(Object.values(error.errors));
      onRemove(file);
    },
    [addErrors, file, onRemove]
  );

  const handleFileRemoveButtonClicked = useCallback(() => {
    onRemove(file);
  }, [file, onRemove]);

  return (
    <li className="uploader-file-preview px-2 mb-2">
      <div className="d-flex">
        <div className="uploader-file-preview-filename flex-4 with-icon">
          <Icon className="icon-document-txt" />
          <span className="with-icon-text" title={filename}>
            {displayName}
          </span>
        </div>

        <Button
          type="button"
          className="uploader-file-preview-remove-button btn-link"
          onClick={handleFileRemoveButtonClicked}
          iconClassName="icon-suppr"
          title={removeFileLabel}
        />
      </div>

      <UploaderFileTransfer
        file={file}
        onUploadStart={handleUploadStarted}
        onUploadComplete={handleUploadCompleted}
        onUploadError={handleUploadError}
        attachmentToken={attachmentToken}
      />
    </li>
  );
};

export default FileInputFile;

const intlMessages = defineMessages({
  removeFile: {
    id: "inputs.files.file.remove",
    defaultMessage: "Supprimer le fichier"
  }
});
